import { Validator } from '@vista-digital/validator';
export const defaultShowtimeSeatPreviewAssets = {
    failedToLoadDataIconName: 'ticket-error-message',
    soldOutIconName: 'ticket-error-message'
};
export const showtimeSeatPreviewAssetsValidatorSchema = {
    failedToLoadDataIconName: Validator.nonEmptyString,
    soldOutIconName: Validator.nonEmptyString
};
export const showtimeSeatPreviewAssetsValidator = Validator.object(showtimeSeatPreviewAssetsValidatorSchema);
//# sourceMappingURL=assets.js.map